// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__37GeU","title":"styles_title__oBNgx","opened":"styles_opened__SXsCU","content":"styles_content__vnxx-","isOpen":"styles_isOpen__RWfMM"};